import request from "@/utils/request";

export function customFieldGet(params) {
    return request({
        url: "/api/services/app/CustomField/Get",
        method: "get",
        params
    });
}

export function customFieldGetAll(params) {
    return request({
        url: "/api/services/app/CustomField/GetAll",
        method: "get",
        params
    });
}

export function customFieldGetHeaders(params) {
    return request({
        url: "/api/services/app/CustomField/GetHeaders",
        method: "get",
        params
    });
}

export function customFieldGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/CustomField/GetAllForDropdown",
        method: "get",
        params
    });
}

export function customFieldGetSubjectLookUpForDropdown(params) {
    return request({
        url: "/api/services/app/CustomField/GetSubjectLookupForDropdown",
        method: "get",
        params
    });
}

export function customFieldCreate(data) {
    return request({
        url: "/api/services/app/CustomField/Create",
        method: "post",
        data
    });
}

export function customFieldCreateMany(data) {
    return request({
        url: "/api/services/app/CustomField/CreateMany",
        method: "post",
        data
    });
}

export function customFieldUpdate(data) {
    return request({
        url: "/api/services/app/CustomField/Update",
        method: "put",
        data
    });
}

export function customFieldUpdateMany(data) {
    return request({
        url: "/api/services/app/CustomField/UpdateMany",
        method: "put",
        data
    });
}

export function customFieldEditManyValue(data) {
    return request({
        url: "/api/services/app/CustomField/EditManyByCustomField",
        method: "put",
        data
    });
}

export function customFieldDelete(params) {
    return request({
        url: "/api/services/app/CustomField/Delete",
        method: "delete",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/custom_field.js